import { type ForwardedRef, forwardRef } from 'react';

export const BaseLineOptimize = forwardRef(
  (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>, ref: ForwardedRef<SVGSVGElement>) => (
    <svg
      width="1em"
      height="1em"
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
    >
      <path
        d="M8.08292 4.74795L10.4765 7.14151M13.6679 2.43457V5.8196M19.2529 4.74795L16.8594 7.14151M21.5663 10.333H18.1813M19.2529 15.918L16.8594 13.5244M13.6679 18.2314V14.8463M5.76953 10.333H9.15456"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
      <path
        d="M13.4596 10.54L4.10547 19.8942"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
    </svg>
  ),
);
